module.exports = __webpack_public_path__ + "static/media/ring.94fb77f9.mp3";